import LightningSvg from './LightningSvg';
import LightningFilledSvg from './LightningFilledSvg';
import LightningBoxSvg from './LightningBoxSvg';
import ChevronRightSvg from './ChevronRightSvg';
import DropDownSvg from './DropDownSvg';
import TimerClockSvg from './TimerClockSvg';

export {
  LightningSvg,
  LightningFilledSvg,
  LightningBoxSvg,
  ChevronRightSvg,
  DropDownSvg,
  TimerClockSvg,
};
